import React, { useState, useEffect } from 'react';
import '../styles/TaskDescriptionModal.css';

const TaskDescriptionModal = ({ show, onClose, description, setDescription }) => {
  const [value, setValue] = useState(description || '');

  useEffect(() => {
    setValue(description || '');
  }, [description]);

  if (!show) return null;

  const handleSave = () => {
    if (typeof setDescription === 'function') {
      setDescription(value);
    }
    onClose();
  };

  return (
    <div className="task-modal-overlay" onClick={onClose}>
      <div className="task-modal" onClick={e => e.stopPropagation()}>
        <h2>Task Description</h2>
        <textarea
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder="Describe your task..."
        />
        <div className="task-modal-buttons">
          <button onClick={handleSave}>Save</button>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default TaskDescriptionModal;
